export const GET_PROJECT_ALTERNATES = "GET_PROJECT_ALTERNATES";
export const GET_PROJECT_ALTERNATE_BY_ID = "GET_PROJECT_ALTERNATE_BY_ID";
export const UPDATE_PROJECT_ALTERNATE = "UPDATE_PROJECT_ALTERNATE";
export const DELETE_PROJECT_ALTERNATE = "DELETE_PROJECT_ALTERNATE";
export const CREATE_PROJECT_ALTERNATE = "CREATE_PROJECT_ALTERNATE";
